import { NavPropsType } from "@/lib/main";
import { CSSProperties } from "react";

export default function Nav({ children, fixed, isDrawerOpen }: NavPropsType) {
  const navStyles: CSSProperties = {
    position: fixed || isDrawerOpen ? "fixed" : "relative",
    zIndex: "var(--z-index-header-nav)",
    top: 0,
    left: 0,
    right: 0,

    backgroundColor: "var(--color-background-navbar)",
    boxShadow: "var(--box-shadow-color) var(--box-shadow-offset)",

    height: "calc(var(--navbar-height) + env(safe-area-inset-top, 0px))",
    overflow: "visible",
    width: "100%",
  };

  const fillerStyle: CSSProperties = {
    height: fixed
      ? "calc(var(--navbar-height) + env(safe-area-inset-top, 0px))"
      : 0,
  };

  // Covers the safe-area strip so the drawer (z-22) doesn't show above the
  // navbar during its slide-in/out animation on iOS.
  const safeAreaCoverStyle: CSSProperties = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "env(safe-area-inset-top, 0px)",
    zIndex: 23, // between drawer (22) and navbar (24)
    backgroundColor: "var(--color-background-navbar)",
  };

  return (
    <>
      <nav style={navStyles} aria-label="Main navigation">
        <div style={safeAreaCoverStyle} aria-hidden="true" />
        {children}
      </nav>
      <div style={fillerStyle} />
    </>
  );
}
